import * as React from 'react'

const UserLogo = (props: any) => {
  const className = props.className || ''
  return (
    <svg
      className={'image-backer svg-grey4 ' + className}
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='22' cy='22' r='23' transform='translate(2 2)' stroke='#D5D5D5' strokeWidth='2' />
      <mask id='mask0' maskUnits='userSpaceOnUse' x='2' y='2' width='44' height='44'>
        <circle cx='22' cy='22' r='22' transform='translate(2 2)' fill='#000' />
      </mask>
      <g mask='url(#mask0)'>
        <path
          d='M22.9565 45.913C17.3154 45.913 12.1268 43.8617 8.12981 40.468C14.8569 38.2357 17.3456 35.5208 18.2657 33.7108C19.5477 34.2689 20.9806 34.5705 22.5644 34.5856C22.5945 34.5856 22.6398 34.5856 22.6699 34.5856C22.685 34.5856 22.7755 34.5856 22.8057 34.5856C22.8359 34.5856 22.8811 34.5856 22.9113 34.5856C24.6307 34.5554 26.1843 34.2085 27.5267 33.56C28.3864 35.3699 30.8299 38.1754 37.7531 40.468C33.7711 43.8617 28.5976 45.913 22.9565 45.913ZM14.5703 18.1601C14.5703 18.1299 14.5703 18.0998 14.5703 18.0696C14.9323 10.2113 20.7242 9.59287 22.504 9.59287C22.5794 9.59287 22.6398 9.59287 22.685 9.59287C22.7303 9.59287 22.7604 9.59287 22.8057 9.59287C22.8509 9.59287 22.8962 9.59287 22.9867 9.59287C24.7514 9.59287 30.5584 10.2113 30.9204 18.0696C30.9204 18.0998 30.9204 18.1299 30.9204 18.1601C30.9355 18.2355 31.6746 25.5056 28.2809 29.3216C26.9385 30.8299 25.1436 31.5841 22.8057 31.5992C22.7906 31.5992 22.7604 31.5992 22.7604 31.5992C22.7454 31.5992 22.7303 31.5992 22.7152 31.5992C20.3622 31.569 18.5824 30.8299 17.24 29.3216C13.8312 25.5357 14.5552 18.2355 14.5703 18.1601ZM22.9565 0C35.6113 0 45.913 10.3018 45.913 22.9565C45.913 28.7484 43.7411 34.0577 40.1965 38.1C30.4528 35.2644 30.0758 31.8254 30.0758 31.7801C30.0758 31.8405 30.0758 31.8556 30.0758 31.8556H29.9702C30.1512 31.6746 30.3322 31.4936 30.5132 31.2975C34.661 26.6368 33.9672 18.6578 33.8918 17.8735C33.4845 9.54762 27.768 6.59133 22.9867 6.59133C22.8962 6.59133 22.8057 6.59133 22.7454 6.59133C22.685 6.59133 22.6096 6.59133 22.504 6.59133C17.7227 6.59133 11.9911 9.54762 11.5989 17.8735C11.5235 18.6427 10.8448 26.6217 14.9775 31.2975C15.2189 31.569 15.4753 31.8254 15.7317 32.0667C15.415 32.9416 13.8161 35.7168 5.7165 38.0849C2.15689 34.0426 0 28.7484 0 22.9565C0 10.3018 10.3018 0 22.9565 0Z'
          transform='translate(1.043 1.043)'
          fill='#D5D5D5'
        />
      </g>
    </svg>
  )
}

export default UserLogo



// WEBPACK FOOTER //
// ./src/components/icons/ui/UserLogo.tsx